import { managedKnowledgeRefSchema } from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import * as z from "zod";

/**
 * Resolves the knowledge entries that fed a particular AI-generated message
 * (or draft), from the `ai_knowledge_use` rows written at agent-execution
 * time:
 *
 *   - `v2_draft`: rows linked to the produced draft.
 *   - `v2_message`: after a draft is promoted to a sent message, those rows
 *     are re-linked to the message id.
 */
export const getKnowledgeSourcesForMessage = {
  name: "getKnowledgeSourcesForMessage" as const,
  input: z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("v2_draft"), draftMessageId: z.string() }),
    z.object({ kind: z.literal("v2_message"), messageId: z.string() }),
  ]),
  output: z.object({
    sources: z.array(
      z.object({
        /** How the knowledge page addresses the entry. */
        ref: managedKnowledgeRefSchema,
        title: z.string(),
      }),
    ),
  }),
};
